/// <amd-module name="Build/Admin/Pool/Actions/PoolGraphActionCreator" />

import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { ActionsHub } from "Build/Admin/Pool/Actions/ActionsHub";
import { PoolAnalyticsSource } from "Build/Admin/Pool/Sources/PoolAnalyticsSource";
import { StoresHub } from "Build/Admin/Pool/Stores/StoresHub";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IPoolGraphActionCreatorOptions {
    pageContext: IVssPageContext;
    actionsHub: ActionsHub;
    storesHub: StoresHub;
    poolAnalyticsSource: PoolAnalyticsSource;
}

export class PoolGraphActionsCreator {
    private _actionsHub: ActionsHub;
    private _poolAnalyticsSource: PoolAnalyticsSource;
    private _storesHub: StoresHub;

    constructor(options: IPoolGraphActionCreatorOptions) {
        this._actionsHub = options.actionsHub;
        this._storesHub = options.storesHub;
        this._poolAnalyticsSource = options.poolAnalyticsSource;
    }

    public updateConfigurationValues(newConfValues: ITrendChartReportConfiguration): Promise<void>[] {
        this._actionsHub.updateConfigurationValuesAction.invoke(newConfValues);
        return [
            this._updatePublicTrendChart(newConfValues),
            this._updatePrivateTrendChart(newConfValues)
            // This code is the start of work for v2. Currently commented out for v1
            // this._updatePipelineConsumptionChart(newConfValues)
        ];
    }

    private async _updatePublicTrendChart(confValues: ITrendChartReportConfiguration): Promise<void> {
        if (this._storesHub.selectionStore.state.selectedAgentPool) {
            const poolId = this._storesHub.selectionStore.state.selectedAgentPool.id;
            const isHosted = this._storesHub.selectionStore.state.selectedAgentPool.isHosted;
            try {
                const publicPoolTrendData = await this._poolAnalyticsSource._queryPublicPoolTrendData(confValues, poolId, isHosted);

                this._actionsHub.updatePublicDataAction.invoke(publicPoolTrendData);
            } catch (error) {
                this._actionsHub.onPublicTrendError.invoke(error);
                return Promise.reject(error);
            }
        }
    }

    private async _updatePrivateTrendChart(confValues: ITrendChartReportConfiguration): Promise<void> {
        if (this._storesHub.selectionStore.state.selectedAgentPool) {
            const poolId = this._storesHub.selectionStore.state.selectedAgentPool.id;
            const isHosted = this._storesHub.selectionStore.state.selectedAgentPool.isHosted;
            try {
                const privatePoolTrendData = await this._poolAnalyticsSource._queryPrivatePoolTrendData(confValues, poolId, isHosted);

                this._actionsHub.updatePrivateDataAction.invoke(privatePoolTrendData);
            } catch (error) {
                this._actionsHub.onPrivateTrendError.invoke(error);
                return Promise.reject(error);
            }
        }
    }

    // This code is the start of work for v2. Currently commented out for v1
    // private async _updatePipelineConsumptionChart(confValues: ITrendChartReportConfiguration): Promise<void> {
    //     try {
    //         const topFivePipelinesData = await this._poolAnalyticsSource._queryTopFivePipelinesData(
    //             {
    //                 entityType: "",
    //                 oDataVersion: AnalyticsODataVersion.v1
    //             },
    //             confValues
    //         );
    //         this._actionsHub.updateTopFivePipelinesAction.invoke(topFivePipelinesData);
    //     } catch (error) {
    //         this._actionsHub.onPipelineConsumptionError.invoke(error);
    //     }
    // }
}
